<template>
  <div class="root-box">
    <div class="condition">
      <div>
        <el-form ref="form" :inline="true" size="small" class="form">
          <el-form-item label="路线：">
            <el-select style="width: 110px" v-model="param.pathId" placeholder="请选择" clearable @change="query()">
              <el-option v-for="item in pathOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="顺路：">
            <el-select style="width: 88px" v-model="param.isOk" placeholder="请选择" clearable @change="query()">
              <el-option v-for="item in yesNoOpts" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快通：">
            <el-select style="width: 88px" v-model="param.quickPass" placeholder="请选择" clearable @change="query()">
              <el-option v-for="item in yesNoOpts" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源：">
            <el-select style="width: 120px" v-model="param.recordSource" placeholder="请选择" clearable @change="query()">
              <el-option v-for="item in recordSourceOpts" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input style="width: 110px" v-model="param.userTel" />
          </el-form-item>
          <el-form-item label="开始：">
            <el-date-picker style="width: 168px" placeholder="选择时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
              v-model="param.startTime"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束：">
            <el-date-picker style="width: 168px" placeholder="选择时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
              v-model="param.endTime"></el-date-picker>
          </el-form-item>
          <el-form-item label="分组：">
            <el-select style="width: 120px" v-model="param.checkRemark" filterable allow-create clearable
              default-first-option placeholder="请选择分组" @change="query()">
              <el-option v-for="item in groupNameOpts" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="onlyIncorrect" @change="query()">只看不合理</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <onway-detect-panel :list="list" show-lab>
      <template #pager>
        <el-pagination @current-change="handleCurrentChange" background :current-page="currentPage" :page-size="10"
          layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </template>
    </onway-detect-panel>
  </div>
</template>

<script>
import { getSortExampleList } from "@/api";
import { mapState } from "vuex";
import { ParamUtil } from "@/util";
import OnwayDetectPanel from "@/components/OnwayDetectPanel";

export default {
  components: { OnwayDetectPanel },
  computed: {
    ...mapState({
      pathOpts: (state) => {
        const pathList = state.pathList || [];
        return pathList.map((item) => ({ label: item.name, value: item.id }));
      }
    })
  },
  mounted() {
    this.query();
  },
  data() {
    return {
      yesNoOpts: [
        { label: "是", value: true },
        { label: "否", value: false }
      ],
      recordSourceOpts: [
        { label: "订票校验", value: "BOOK" },
        { label: "改签校验", value: "CHANGE_ORDER" },
        { label: "客服匹配", value: "CS_MATCH" },
        { label: "系统自动分派", value: "AUTO_DISPATCH" }
      ],
      param: {},
      onlyIncorrect: false,
      list: [],
      groupNameOpts: ["经典案例", "问题待确认", "完美规划", "默认分组", "已查无问题", "相同问题"],
      total: 0,
      currentPage: 1
    };
  },
  methods: {
    query(page = 1) {
      const _param = ParamUtil.filterEmptyData(this.param);
      if (this.onlyIncorrect) {
        _param.incorrect = true;
      }
      const param = {
        param: _param,
        startTime: _param.startTime,
        endTime: _param.endTime,
        page: { current: page, size: 10 }
      };
      getSortExampleList(param).then((res) => {
        const { content = [], totalElements = 0 } = res.data || {};
        this.list = content;
        this.currentPage = page;
        this.total = totalElements;
      });
    },
    handleCurrentChange(page) {
      this.query(page);
    }
  }
};
</script>

<style scoped lang="less">
.root-box {
  position: relative;

  .condition {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: normal;
    padding: 6px 8px;
    position: relative;
    overflow-x: auto;

    .form {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      white-space: nowrap;
    }

    .el-form-item {
      margin: 0 6px 0 0;
      flex-shrink: 0;
    }
  }
}
</style>
